import React, { memo } from 'react';
import { Drawer } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SheetForm from 'pages/Worklogs/components/SheetForm/SheetForm';
import { ScheduleFilters } from 'pages/ScheduleV6/components/header/ScheduleFilters';
import NoteCreationForm from 'components/NoteCreationForm/NoteCreationForm';
import ResourcesForm from 'components/ResourcesForm/ResourcesForm';
import CommentsForm from 'components/CommentsForm/CommentsForm';
import MaterialForm from 'components/MaterialForm/MaterialForm';
import TimeForm from 'components/WorklogDetails/components/TimeBlock/components/TimeForm/TimeForm';
import WeatherForm from 'components/WorklogDetails/components/WeatherBlock/components/WeatherForm/WeatherForm';
import NotesForm from 'components/WorklogDetails/components/NotesBlock/components/NotesForm/NotesForm';
import GeneralInfoForm from 'components/WorklogDetails/components/GeneralInfoBlock/components/GeneralInfoForm/GeneralInfoForm';
import { DRAWER_TYPES } from 'pages/ScheduleV6/constants/constants';
import { WORKLOG_DRAWER_TYPES } from 'components/WorklogDetails/constants';

const useFiltersMobileStyles = makeStyles({
  mobileSpace: { justifyContent: 'flex-start' },
});

export const ScheduleDrawer = memo(
  ({
    drawer,
    additionalDrawer,
    openSnackbar,
    closeDrawer,
    closeAdditionalDrawer,
    selectedDate,
    isMobile,
  }) => {
    const filtersMobileStyles = useFiltersMobileStyles();

    return (
      <>
        <Drawer
          anchor="right"
          open={drawer.open}
        >
          {drawer.type === WORKLOG_DRAWER_TYPES.update && (
            <SheetForm
              closeDrawer={closeDrawer}
              type={drawer.type}
              sheet={drawer.data}
              openSnackbar={openSnackbar}
            />
          )}
          {drawer?.type === DRAWER_TYPES.addWorklog && (
            <SheetForm
              closeDrawer={closeDrawer}
              type="create"
              openSnackbar={openSnackbar}
              defaultDate={selectedDate}
            />
          )}
          {drawer?.type === DRAWER_TYPES.filters && (
            <ScheduleFilters
              closeDrawer={closeDrawer}
              mobileStyles={isMobile ? filtersMobileStyles : {}}
            />
          )}
          {drawer?.type === DRAWER_TYPES.addNote && (
            <NoteCreationForm
              onSuccess={closeDrawer}
              closeDrawer={closeDrawer}
              openSnackbar={openSnackbar}
            />
          )}
        </Drawer>

        <Drawer
          anchor="left"
          open={additionalDrawer.open}
        >
          {additionalDrawer.type === 'resources' && (
            <ResourcesForm
              closeDrawer={closeAdditionalDrawer}
              type={additionalDrawer?.data.subType}
              openSnackbar={openSnackbar}
            />
          )}
          {additionalDrawer.type === 'comments' && (
            <CommentsForm
              closeDrawer={closeAdditionalDrawer}
              openSnackbar={openSnackbar}
              limiterW={true}
            />
          )}
          {additionalDrawer.type === 'material' && (
            <MaterialForm
              closeDrawer={closeAdditionalDrawer}
              openSnackbar={openSnackbar}
              type={additionalDrawer?.data.subType}
              material={additionalDrawer?.data.material}
            />
          )}
          {additionalDrawer.type === 'time' && (
            <TimeForm
              closeDrawer={closeAdditionalDrawer}
              openSnackbar={openSnackbar}
            />
          )}
          {additionalDrawer.type === 'weather' && (
            <WeatherForm closeDrawer={closeAdditionalDrawer} />
          )}
          {additionalDrawer.type === 'notes' && (
            <NotesForm
              closeDrawer={closeAdditionalDrawer}
              openSnackbar={openSnackbar}
            />
          )}
          {additionalDrawer.type === 'general' && (
            <GeneralInfoForm closeDrawer={closeAdditionalDrawer} />
          )}
        </Drawer>
      </>
    );
  },
  (prevProps, nextProps) => {
    const drawerClosed =
      prevProps.drawer.open === nextProps.drawer.open &&
      nextProps.drawer.open === false;
    const additionalDrawerClosed =
      prevProps.additionalDrawer.open === nextProps.additionalDrawer.open &&
      nextProps.additionalDrawer.open === false;
    return drawerClosed && additionalDrawerClosed;
  }
);
